export default __webpack_public_path__ + "static/media/slide8.44467df4.png";